import React from "react";
import { CloseIcon } from "asset/icons";
import USFlag from "asset/images/US.png";
import EUFlag from "asset/images/EU.svg";

const ConversionConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    amount,
    convertedAmount,
    fee,
    rate,
    fromCurrency,
    toCurrency,
}) => {
    if (!isOpen) return null;

    const withCode = (value, code) =>
        [String(value ?? "").trim(), String(code ?? "").toUpperCase()].filter(Boolean).join(" ");

    const rateDisplay =
        rate !== undefined && rate !== null && rate !== ""
            ? `1 ${String(fromCurrency).toUpperCase()} = ${rate} ${String(
                  toCurrency
              ).toUpperCase()}`
            : "—";
    const imgUrl = (code) =>
        code
            ? `https://trade-vu.lon1.digitaloceanspaces.com/trade-vu/${String(
                  code
              ).toLowerCase()}.png`
            : "";

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
            <div className="bg-white rounded-2xl w-full max-w-xl relative">
                <div className="px-6 pt-6">
                    <button
                        onClick={onClose}
                        className="absolute top-5 right-5 text-gray-500 hover:text-black"
                    >
                        <CloseIcon />
                    </button>

                    <h2 className="text-2xl font-semibold mb-10 text-[#101828]">
                        Confirm conversion details
                    </h2>

                    <div className="flex justify-around items-center mb-8">
                        <div className="flex flex-col items-center">
                            <span className="border rounded-full p-3">
                                <img
                                    src={imgUrl(fromCurrency)}
                                    alt={`${fromCurrency} icon`}
                                    className="w-12 h-12 rounded-full"
                                    loading="lazy"
                                    // onError={(e) => {
                                    //     e.currentTarget.onerror = null;
                                    //     e.currentTarget.src =
                                    //         FALLBACKS[String(fromCurrency).toUpperCase()] ||
                                    //         GenericCurrencyIcon;
                                    // }}
                                />
                            </span>

                            <span className="text-md text-gray-400 mt-2">From</span>
                            <span className="text-xl font-semibold text-[#101828]">
                                {withCode(amount, fromCurrency)}
                            </span>
                        </div>
                        <span className="text-2xl text-gray-400">→</span>
                        <div className="flex flex-col items-center">
                            <span className="border rounded-full p-3">
                                <img
                                    src={imgUrl(toCurrency)}
                                    alt={`${toCurrency} icon`}
                                    className="w-12 h-12 rounded-full"
                                    loading="lazy"
                                    // onError={(e) => {
                                    //     e.currentTarget.onerror = null;
                                    //     e.currentTarget.src =
                                    //         FALLBACKS[String(toCurrency).toUpperCase()] ||
                                    //         GenericCurrencyIcon;
                                    // }}
                                />
                            </span>

                            <span className="text-md text-gray-400 mt-2">To</span>
                            <span className="text-xl font-semibold text-[#101828]">
                                {withCode(convertedAmount, toCurrency)}
                            </span>
                        </div>
                    </div>

                    <div className="border-t pt-4 space-y-4 !text-lg text-[#161827] font-thin">
                        <div className="flex justify-between">
                            <span>Conversion fee</span>
                            <span>{withCode(fee, fromCurrency)}</span>
                        </div>
                        <div className="flex justify-between">
                            <span>Exchange rate</span>
                            <span>{rateDisplay}</span>
                        </div>
                    </div>
                </div>
                <div className="mt-6 flex justify-end gap-4 px-6 pb-6 border-t pt-3">
                    <button onClick={onClose} className="text-[#344054] font-medium text-sm">
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="bg-[#6F00FF] text-white px-6 !py-3 rounded-lg font-medium text-sm"
                    >
                        Confirm and convert
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConversionConfirmModal;
